// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"3513a133","219":"5f301b25","591":"d5284439","787":"73fd2281","947":"746d7446"}[chunkId] + ".chunk.js";
};